import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Links from "./Links";



class Navbar extends Component {
  render() {
    return <Links />;
  }
}

export default withRouter(Navbar);
